import { useCallback, useEffect, useState } from 'react'

type LocalStorage = Pick<Storage, 'getItem' | 'setItem'>

const STORAGE_KEY_PREFIX = 'agrid.realtime.showInletTemperature'

export const getShowInletTemperatureStorageKey = (siteHash: string) => `${STORAGE_KEY_PREFIX}.${siteHash}`

const getStorage = (storage?: LocalStorage): LocalStorage | null => {
    if (storage) {
        return storage
    }
    return typeof window === 'undefined' ? null : window.localStorage
}

export const getShowInletTemperaturePreference = (siteHash: string, storage?: LocalStorage): boolean => {
    return getStorage(storage)?.getItem(getShowInletTemperatureStorageKey(siteHash)) === 'true'
}

export const setShowInletTemperaturePreference = (siteHash: string, value: boolean, storage?: LocalStorage): void => {
    getStorage(storage)?.setItem(getShowInletTemperatureStorageKey(siteHash), JSON.stringify(value))
}

const useShowInletTemperature = (siteHash: string) => {
    const [showInletTemperature, setShowInletTemperatureState] = useState(() =>
        getShowInletTemperaturePreference(siteHash)
    )

    useEffect(() => {
        setShowInletTemperatureState(getShowInletTemperaturePreference(siteHash))
    }, [siteHash])

    const setShowInletTemperature = useCallback(
        (value: boolean) => {
            setShowInletTemperatureState(value)
            setShowInletTemperaturePreference(siteHash, value)
        },
        [siteHash]
    )

    return [showInletTemperature, setShowInletTemperature] as const
}

export default useShowInletTemperature
